module.exports = __webpack_public_path__ + "static/media/twitter_logo.b696dd8e.png";